/**
 * Icon components for special dates
 * SVG icons for holidays and special occasions
 */

export const icons = {
  'jack-o-lantern': (
    <svg className="w-9 h-9" fill="currentColor" viewBox="0 0 24 24">
      <path d="M12 2C11.5 2 11 2.19 10.59 2.59L10 3.17V2C10 1.45 9.55 1 9 1S8 1.45 8 2V4.17C6.84 4.58 6 5.69 6 7C6 7.7 6.2 8.37 6.56 8.94C5.5 9.75 5 11.3 5 12.5C5 15.47 6.5 18.74 9.5 19.91C10.28 20.11 11.14 20 12 20S13.72 20.11 14.5 19.91C17.5 18.74 19 15.47 19 12.5C19 11.3 18.5 9.75 17.44 8.94C17.8 8.37 18 7.7 18 7C18 5.69 17.16 4.58 16 4.17V2C16 1.45 15.55 1 15 1S14 1.45 14 2V3.17L13.41 2.59C13 2.19 12.5 2 12 2M9 11C9.83 11 10.5 11.67 10.5 12.5S9.83 14 9 14 7.5 13.33 7.5 12.5 8.17 11 9 11M15 11C15.83 11 16.5 11.67 16.5 12.5S15.83 14 15 14 13.5 13.33 13.5 12.5 14.17 11 15 11M12 17.23C10.25 17.23 8.71 16.5 7.81 15.42L9.23 14C9.68 14.72 10.75 15.23 12 15.23S14.32 14.72 14.77 14L16.19 15.42C15.29 16.5 13.75 17.23 12 17.23Z" />
    </svg>
  ),
  'gift': (
    <svg className="w-9 h-9" fill="currentColor" viewBox="0 0 24 24">
      <path d="M22 12V20C22 21.11 21.11 22 20 22H4C2.9 22 2 21.11 2 20V12H22M13 2V11H11V2H13M17 7C18.11 7 19 6.11 19 5S18.11 3 17 3 15 3.9 15 5 15.9 7 17 7M7 7C8.11 7 9 6.11 9 5S8.11 3 7 3 5 3.9 5 5 5.9 7 7 7M20 10H4C2.9 10 2 10.89 2 12V20C2 21.11 2.9 22 4 22H20C21.11 22 22 21.11 22 20V12C22 10.89 21.11 10 20 10M13 10H11V2H13V10Z" />
    </svg>
  ),
  'champagne': (
    <svg className="w-9 h-9" fill="currentColor" viewBox="0 0 24 24">
      <path d="M13 2V10C13 10.7 12.74 11.37 12.31 11.9L8.5 16.5V19H11V21H7V19H9.5V16.5L5.69 11.9C5.26 11.37 5 10.7 5 10V2H13M7 4V10C7 10.27 7.11 10.5 7.28 10.68L9 12.69V4H7M16 7V21H18V11.5L22 7H16M18 9H20L18 10.89V9Z" />
    </svg>
  ),
  'heart': (
    <svg className="w-9 h-9" fill="currentColor" viewBox="0 0 24 24">
      <path d="M12 21.35L10.55 20.03C5.4 15.36 2 12.27 2 8.5C2 5.41 4.42 3 7.5 3C9.24 3 10.91 3.81 12 5.08C13.09 3.81 14.76 3 16.5 3C19.58 3 22 5.41 22 8.5C22 12.27 18.6 15.36 13.45 20.03L12 21.35Z" />
    </svg>
  ),
  'crown': (
    <svg className="w-9 h-9" fill="currentColor" viewBox="0 0 24 24">
      <path d="M5 16L3 5l5.5 5L12 4l3.5 6L21 5l-2 11H5m14 3c0 .6-.4 1-1 1H6c-.6 0-1-.4-1-1v-1h14v1z" />
    </svg>
  )
}

export const getIcon = (iconName) => {
  return icons[iconName] || icons['crown']
}
